function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useRef, useCallback, useEffect } from 'react';
import { withTheme } from '../../core/theming';
import Text, { TextType } from '../Typography/Text';
import Badge from '../Badge';
import { View, TouchableOpacity, FlatList, StyleSheet, Platform } from 'react-native';

const Tabs = _ref => {
  let {
    style,
    values = [],
    selectedIndex = 0,
    theme: {
      colors,
      isRTL
    },
    fullWidth = false,
    onChange
  } = _ref;
  const flatListRef = useRef(null);
  useEffect(() => {
    if ((values === null || values === void 0 ? void 0 : values.length) > selectedIndex) {
      var _flatListRef$current;

      flatListRef === null || flatListRef === void 0 ? void 0 : (_flatListRef$current = flatListRef.current) === null || _flatListRef$current === void 0 ? void 0 : _flatListRef$current.scrollToIndex({
        animated: true,
        index: selectedIndex
      });
    }
  }, [selectedIndex, values]);
  const renderItemBottomBoarder = useCallback(() => {
    return /*#__PURE__*/React.createElement(View, {
      style: [styles.itemBottomBoarder, {
        backgroundColor: colors.background.headerModal
      }]
    });
  }, [colors]);
  const renderItemBadge = useCallback(badge => {
    return /*#__PURE__*/React.createElement(Badge, {
      style: {
        marginHorizontal: 4
      },
      type: badge.type,
      value: badge.count,
      isBold: true
    });
  }, []);
  const renderItem = useCallback(_ref2 => {
    let {
      item,
      index
    } = _ref2;
    const badge = item === null || item === void 0 ? void 0 : item.badge;
    return /*#__PURE__*/React.createElement(TouchableOpacity, _extends({
      style: fullWidth && styles.fullWidthItem,
      key: index,
      accessibilityRole: onChange ? 'button' : undefined
    }, item === null || item === void 0 ? void 0 : item.accessibility, {
      onPress: () => onChange && onChange(index)
    }), /*#__PURE__*/React.createElement(View, {
      style: [styles.itemButton, {
        flexDirection: isRTL && Platform.OS === 'ios' ? 'row-reverse' : 'row'
      }]
    }, /*#__PURE__*/React.createElement(Text, {
      type: TextType.ButtonPrimary
    }, item.name), badge && ((badge === null || badge === void 0 ? void 0 : badge.count) || 0) > 0 && renderItemBadge(badge)), index === selectedIndex && renderItemBottomBoarder());
  }, [renderItemBottomBoarder, renderItemBadge, onChange, selectedIndex, fullWidth, isRTL]);

  const renderFullWidth = () => {
    return values.map((x, i) => renderItem({
      item: x,
      index: i
    }));
  };

  return /*#__PURE__*/React.createElement(View, {
    style: [{
      backgroundColor: colors.background.white,
      borderBottomColor: colors.line.light
    }, fullWidth ? styles.fullWidthContainer : styles.container, style]
  }, fullWidth ? renderFullWidth() : /*#__PURE__*/React.createElement(FlatList, {
    horizontal: true,
    showsHorizontalScrollIndicator: false,
    ref: flatListRef,
    data: values || [],
    keyExtractor: item => item.name,
    renderItem: renderItem,
    onScrollToIndexFailed: () => console.log('scrollToIndex Error'),
    contentContainerStyle: {
      flexGrow: 1
    } // This is needed to fix bug with wrong index on iOS when RTL
    // direction is only for iOS, so no need to check Android
    ,
    style: isRTL && {
      direction: 'ltr'
    },
    inverted: isRTL && Platform.OS === 'ios'
  }));
};

const styles = StyleSheet.create({
  container: {
    minHeight: 48,
    borderBottomWidth: 1
  },
  fullWidthItem: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  fullWidthContainer: {
    minHeight: 48,
    borderBottomWidth: 1,
    flex: 1,
    flexDirection: 'row'
  },
  itemButton: {
    flex: 1,
    alignItems: 'center',
    paddingHorizontal: 24
  },
  itemBottomBoarder: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: 2
  }
});
export default withTheme(Tabs);
//# sourceMappingURL=index.js.map